/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Message_HintInputs */

const en_contact_message_hint = /** @type {(inputs: Contact_Message_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The more context you give, the more specific we can be.`)
};

/**
* | output |
* | --- |
* | "The more context you give, the more specific we can be." |
*
* @param {Contact_Message_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_message_hint = /** @type {((inputs?: Contact_Message_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Message_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_message_hint(inputs)
});